import { monitorForElements } from '@atlaskit/pragmatic-drag-and-drop/adapter/element-adapter';
import type { ElementDragType, CleanupFn } from '@atlaskit/pragmatic-drag-and-drop/internal-types';

import type { ElementAutoScrollArgs, WindowAutoScrollArgs } from '../internal-types';
import { makeApi } from '../over-element/make-api';

const api = makeApi({ monitor: monitorForElements });

export const autoScrollForElements: (args: ElementAutoScrollArgs<ElementDragType>) => CleanupFn =
	api.autoScroll;
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const autoScrollWindowForElements: (
	args?: WindowAutoScrollArgs<ElementDragType>,
) => CleanupFn = api.autoScrollWindow;
